module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAYAAABvEu28AAAAAXNSR0IArs4c6QAAARhJREFUKBVjYKASYLx9+zbfv3//bMg1j5mZ+ZGKisoVFiYmJom/f/+uAhrETY5hf/78aQHqu8KkrKx8C8hIJMcQoJ5d6urqDSC9TCBCQ0NjNZBqBbGJBYyMjHc4OTkjgPRfkB5GmMb///8z3bp1ayOQ9oGJ4aE/A8PGUlVV9SpMDdhFIA7Q5H/A8IoG0jdgkthooPx/II5DNgSkDm4QiAOU/MTCwuIPVPgRxMcBGoDhsgFdDu41ZImbN296AfmbQd5FFgdasF5NTS0Y5CpkcRAbRSFMEmjjNiC7GsaH0lcEBQXjsBkCksdqEEgCaFgHUNNKEBsI3gEDN0BMTOwLhItJ4jQIpJSXlzcJaNghYCREAMPvLqZ2hAgAIWpA3asMTWIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down.png
// module id = jIOt
// module chunks = 1